import React from 'react';
import PropTypes from 'prop-types';

import {connect, ssr_wait} from '@stubhub/react-store-provider';

import {query} from '../../../../modules/react-query';

import controller from './controller';

@query({
  quantity: 'qty',
  priceWithFees: 'priceWithFees',
  listingCategory: 'categ',
  excludeCategory: 'excl',
  deliveryType: 'dt',
  sort: 'sort',
  sortKey: 'sortKey',
  sliderMin: 'sliderMin',
  sliderMax: 'sliderMax',
  sectionIdList: 'sid',
  zoneIdList: 'zid',
  listingRows: 'rid',
})
@connect(controller)
class TicketListProvider extends React.Component {
  static defaultProps = {
    page: 1,
  };

  @ssr_wait
  init() {
    return this.fetchInventoryListings();
  }

  async fetchInventoryListings() {
    const {eventId, fetchInventoryListings, ...otherProps} = this.props;
    fetchInventoryListings && (await fetchInventoryListings(eventId, otherProps, true));
  }

  UNSAFE_componentWillMount() {
    const {reset, listings, enableSSR, loading} = this.props;
    if (!loading && enableSSR && (reset || !listings.length)) {
      this.init();
    }
  }

  componentDidMount() {
    const {reset, listings, loading} = this.props;
    if (!loading && (reset || !listings.length)) {
      this.fetchInventoryListings();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {isQueryUpdated, getQuery, fetchInventoryListings, page, shstore} = this.props;
    const {eventId} = nextProps;
    if (fetchInventoryListings) {
      if (isQueryUpdated && isQueryUpdated(this.props, nextProps)) {
        fetchInventoryListings(
          eventId,
          {
            ...((getQuery && getQuery(nextProps)) || {}),
            shstore,
          },
          page === nextProps.page
        );
      } else if (page < nextProps.page) {
        fetchInventoryListings(
          eventId,
          {
            ...((getQuery && getQuery(nextProps)) || {}),
            page: nextProps.page,
            shstore,
          },
          page === nextProps.page
        );
      }
    }
  }

  render() {
    return null;
  }
}

TicketListProvider.propTypes = {
  isQueryUpdated: PropTypes.func,
  getQuery: PropTypes.func,
  fetchInventoryListings: PropTypes.func,
  page: PropTypes.number,
  reset: PropTypes.bool,
  listings: PropTypes.array,
  loading: PropTypes.bool,
  enableSSR: PropTypes.bool,
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shstore: PropTypes.number,
};

export default TicketListProvider;
